import { defineAsyncComponent } from "vue";
import type { Component } from "vue";

export interface ComponentMapper<T extends string> {
  getComponentByAlias: (alias: string | undefined) => Component | null;
  isValidAlias: (alias: string) => alias is T;
}

export function createComponentMapper<T extends string>(
  componentMap: Record<T, () => Promise<Component>>,
): ComponentMapper<T> {
  const isValidAlias = (alias: string | undefined): alias is T => {
    if (alias === undefined) {
      console.warn("Alias is undefined. Please provide a valid alias.");
      return false;
    }
    return Object.keys(componentMap).includes(alias);
  };

  function getComponentByAlias(alias: string | undefined): Component | null {
    if (!isValidAlias(alias)) {
      console.warn(
        `Invalid alias: ${alias}.  Available aliases are: ${Object.keys(componentMap).join(", ")}`,
      );
      return null;
    }
    return defineAsyncComponent(componentMap[alias]);
  }

  return {
    getComponentByAlias,
    isValidAlias,
  };
}
